<template>
  <v-col cols="12" md="3" sm="12">
    <v-card :loading="loading" class="mx-auto" height="180">
      <template slot="progress">
        <v-progress-linear color="indigo" indeterminate></v-progress-linear>
      </template>

      <v-card-text>
        <div class="text-h6 font-weight-black">Graus acadêmicos</div>
      </v-card-text>

      <apexchart height="100" :options="chartOptions" :series="series"></apexchart>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "ProfessorGeneroCard",
  mounted() {
    this.getGenero();
  },

  data() {
    return {
      qtd: 0,
      loading: true,
      series: [],
      chartOptions: {
        chart: {
          height: 400,
          type: "donut",
          offsetX: -10,
        },

        legend: {
          show: true,
          horizontalAlign: "top",
          position: "right",
          offsetY: -5,
        },

        labels: [
          "Técnico",
          "Superior Incompleto",
          "Graduação",
          "Pós-Graduação",
          "Mestrado",
          "Doutorado",
          "Pós-Doutorado",
        ],
        responsive: [
          {
            breakpoint: 400,
            options: {
              chart: {
                width: 400,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },
    };
  },

  methods: {
    async getGenero() {
      try {
        const response = await this.$services.professoresService.grausAcademicos();

        this.loading = false;
        this.series = [
          parseInt(response.tecnico || 0, 10),
          parseInt(response.superiorIncompleto || 0, 10),
          parseInt(response.graduacao || 0, 10),
          parseInt(response.posGraduacao || 0, 10),
          parseInt(response.mestrado || 0, 10),
          parseInt(response.doutorado || 0, 10),
          parseInt(response.posDoutorado || 0, 10),
        ];
      } catch (error) {
        this.loading = false;
        console.error("Erro ao carregar graus acadêmicos:", error);
      }
    },
  },
};
</script>

<style scoped>
div.chart-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
